interface DigitalIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const DigitalIcon = (props: DigitalIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <g>
        <g>
          <path
            style={{ fill: fillColor }}
            d="M20,5.9C12.2,5.9,5.9,12.2,5.9,20c0,7.8,6.3,14.1,14.1,14.1c7.8,0,14.1-6.3,14.1-14.1
              C34.1,12.2,27.8,5.9,20,5.9z M16.7,7.3c-1.2,1.1-2.2,2.8-3,4.9c-1.1-0.4-2-1-2.8-1.6C12.6,9,14.5,7.9,16.7,7.3z M10.3,11.3
              c0.9,0.7,1.9,1.4,3.1,1.9c-0.6,1.9-0.9,4-0.9,6.3H7C7.1,16.3,8.3,13.5,10.3,11.3z M7,20.5h5.5c0,2.3,0.4,4.4,0.9,6.3
              c-1.2,0.5-2.3,1.1-3.1,1.9C8.3,26.5,7.1,23.6,7,20.5z M11,29.4c0.8-0.6,1.7-1.2,2.8-1.6c0.7,2.1,1.8,3.8,3,4.9
              C14.5,32.1,12.6,30.9,11,29.4z M19.5,33c-2-0.3-3.8-2.5-4.9-5.6c1.5-0.5,3.1-0.8,4.9-0.8V33z M19.5,25.5c-1.9,0.1-3.6,0.4-5.2,0.9
              c-0.5-1.8-0.8-3.8-0.9-6h6V25.5z M19.5,19.5h-6c0-2.2,0.3-4.2,0.9-6c1.6,0.5,3.3,0.9,5.2,0.9V19.5z M19.5,13.4
              c-1.8,0-3.4-0.3-4.9-0.8c1.1-3.2,2.9-5.3,4.9-5.6V13.4z M33.1,19.5h-5.5c0-2.3-0.4-4.4-0.9-6.3c1.2-0.5,2.3-1.1,3.1-1.9
              C31.7,13.5,33,16.3,33.1,19.5z M29.1,10.6c-0.8,0.6-1.7,1.2-2.8,1.6c-0.7-2.1-1.8-3.8-3-4.9C25.5,7.9,27.5,9,29.1,10.6z M20.5,6.9
              c2,0.3,3.8,2.5,4.9,5.6c-1.5,0.5-3.1,0.8-4.9,0.8V6.9z M20.5,14.4c1.9-0.1,3.6-0.4,5.2-0.9c0.5,1.8,0.8,3.8,0.9,6h-6V14.4z
               M20.5,20.5h6c0,2.2-0.3,4.2-0.9,6c-1.6-0.5-3.3-0.9-5.2-0.9V20.5z M20.5,33v-6.5c1.8,0,3.4,0.3,4.9,0.8
              C24.3,30.6,22.6,32.7,20.5,33z M23.3,32.6c1.2-1.1,2.2-2.8,3-4.9c1.1,0.4,2,1,2.8,1.6C27.5,30.9,25.5,32.1,23.3,32.6z M29.8,28.7
              c-0.9-0.7-1.9-1.4-3.1-1.9c0.6-1.9,0.9-4,0.9-6.3h5.5C33,23.6,31.7,26.5,29.8,28.7z"
          />
        </g>
      </g>
    </svg>
  )
}

export default DigitalIcon
